export enum CountryNames {
  Russia = 'Россия',
  Kazakhstan = 'Казахстан',
  Lithuania = 'Литва',
  Latvia = 'Латвия',
  Estonia = 'Эстония',
  Moldova = 'Молдавия',
  Armenia = 'Армения',
  Belarus = 'Беларусь (Белоруссия)',
  Tajikistan = 'Таджикистан',
  Turkmenistan = 'Туркмения',
  Azerbaijan = 'Азербайджан',
  Georgia = 'Грузия',
  Kyrgyzstan = 'Киргизия',
  Uzbekistan = 'Узбекистан',
}
